// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23VCE","name":"styles_name__6PaaT","phone":"styles_phone__2KZa6"};